<div class="hmn-dialog__max-width-m hmn-dialog__min-width hmn-padding__x4">
  <div class="hmn-width__full hmn-row__space">
    <h4 class="hmn-margin__x1-left">{{ 'SHARED.HELP_DIALOG_TITLE' | translate }}</h4>

    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="hmn-icon__button-main">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="hmn-padding__x4">
    <h5
      class="hmn-margin__x2-top hmn-margin__x2-bottom"
      [innerHTML]="
        'SHARED.HELP_DIALOG_MESSAGE' | translate : { phone_number: '+39 34567231', wa_link: 'https://google.com' }
      "></h5>
  </div>
</div>
